import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import ApplicationCreate from './ApplicationCreate';
import ApplicationEdit from './ApplicationEdit';
import ApplicationList from './ApplicationList';
import { Alert } from 'antd';
import {
  checkCanEditApiManagement,
  checkCanViewApiManagement,
} from '@src/globalStore/profileStore';
import { homePagePath } from '@src/routers/utils';

const Apps = () => {
  const createErrorMessage = 'You do not have permission to create an application.';
  const canViewApiManagement = checkCanViewApiManagement();
  const canEditApiManagement = checkCanEditApiManagement();
  const renderErrorMessage = (message: string) => <Alert message={message} type="error" showIcon />;

  if (!canViewApiManagement) {
    return <Navigate to={homePagePath} replace />;
  }

  return (
    <Routes>
      <Route path={`/list`} element={<ApplicationList />} />
      <Route
        path={`/create`}
        element={
          canEditApiManagement ? <ApplicationCreate /> : renderErrorMessage(createErrorMessage)
        }
      />
      <Route path={`/detail/:clientId`} element={<ApplicationEdit />} />
    </Routes>
  );
};

export default Apps;
